import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { InputValidation } from '../validations/input.validation';
import { AppStateService } from '../services/app-state.service';

@Component({
  selector: 'only-number-input',
  template: `
    <input type="number" [pattern]="pattern" [min]="minValue" [max]="maxValue"
           #inputTypeNumber
           (change)="handleNumberChanged(inputTypeNumber.value)"
           [value]="inputNumberValue"
           (paste)="onpaste($event)"
           (mousedown)="selectInputShowCursorInAllBrowsers($event)"
           (keyup.enter)="handleEnter($event)"
           (keyup)="onKeyUp($event)"
           [ngClass]="classString"
    />
  `
})

export class OnlyNumberInputComponent implements AfterViewInit {
  @Input() inputNumberValue: string;
  @Input() pattern: string; //[0-9]*
  @Input() classString: string;
  @Input() minValue: number;
  @Input() maxValue: number;
  @Input() defaultValue: number;

  @Output() numberChanged: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputTypeNumber', {static: false}) inputTypeNumber: ElementRef;

  classObject: string;

  constructor(private appStateService: AppStateService) {

  }

  ngAfterViewInit() {
    this.classObject = `{${this.classString}: true}`;
  }

  onpaste(event: any) {
    const inputDomElement = this.inputTypeNumber.nativeElement;
    const currentValue = this.inputNumberValue;

    setTimeout(() => {
      const inputDomElementValue = inputDomElement.value;
      if (this.isNumberValid(inputDomElementValue) === false) {
        inputDomElement.value = currentValue;
      } else {
        let valueAsNumber = Number(inputDomElementValue);
        if (valueAsNumber < this.minValue || valueAsNumber > this.maxValue) {
          valueAsNumber = this.defaultValue;
        }
        this.numberChanged.next(valueAsNumber);
      }
    }, 1);
  }

  changeSelectedNumber(value: string) {

    if (this.isNumberValid(value) === false) {
      this.inputTypeNumber.nativeElement.value = this.inputNumberValue;
    } else {
      let valueAsNumber = Number(value);
      if (valueAsNumber < this.minValue || valueAsNumber > this.maxValue) {
        valueAsNumber = this.defaultValue;
        this.inputTypeNumber.nativeElement.value = this.defaultValue;
      }

      this.numberChanged.next(valueAsNumber);
    }
  }

  isNumberValid(value: string): boolean {
    let isValid: boolean = false;
    isValid = InputValidation.onlyNumberValidation(value);
    return isValid;
  }

  handleNumberChanged(value: string) {
    this.changeSelectedNumber(value);
  }

  handleEnter(event: any) {
    const inputValue = event.target.value || null;
    this.changeSelectedNumber(inputValue);
  }

  onKeyUp($event: any) {
    const inputValue = this.inputTypeNumber.nativeElement.value;
    if (inputValue !== '') {
      this.changeSelectedNumber(this.inputTypeNumber.nativeElement.value);
    }
  }

  selectInputShowCursorInAllBrowsers(event: any) {
    if (this.appStateService.isBrowserEdge() || this.appStateService.isBrowserIE()) {
      const target: HTMLInputElement = event.target || event.srcElement || event.currentTarget;
      target.select();
    }
  }
}
